import React from 'react'
import Hero from './hero'
import Picker from './picker'

const EmojiPickerContent = ({ emoji, label, doneAction }) => {
    const onEmojiPicked = emoji => doneAction({ picked: emoji }).onClick()

    return (
        <>
            <Hero label={label} />
            <Picker
                emoji={emoji}
                pickEmoji={onEmojiPicked} />
        </>
    )
}

export default EmojiPickerContent